import { createRouter, createWebHistory } from 'vue-router'
import ReaderView from "@/views/ReaderView.vue";
import BookList from '@/views/BookList.vue';

const routes = [
    { path: '/', component: ReaderView },
    { path: '/list', component: BookList },
]

export default createRouter({
    history: createWebHistory(),
    routes
})
